var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scan-barcode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 10.353C2.09 10.353 1.75 10.013 1.75 9.60303V7.10303C1.75 4.20303 4.11 1.85303 7 1.85303H9.5C9.91 1.85303 10.25 2.19303 10.25 2.60303C10.25 3.01303 9.91 3.35303 9.5 3.35303H7C4.93 3.35303 3.25 5.03303 3.25 7.10303V9.60303C3.25 10.013 2.91 10.353 2.5 10.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5 10.353C22.09 10.353 21.75 10.013 21.75 9.60303V7.10303C21.75 5.03303 20.07 3.35303 18 3.35303H15.5C15.09 3.35303 14.75 3.01303 14.75 2.60303C14.75 2.19303 15.09 1.85303 15.5 1.85303H18C20.89 1.85303 23.25 4.20303 23.25 7.10303V9.60303C23.25 10.013 22.91 10.353 22.5 10.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18 23.353H16.5C16.09 23.353 15.75 23.013 15.75 22.603C15.75 22.193 16.09 21.853 16.5 21.853H18C20.07 21.853 21.75 20.173 21.75 18.103V16.603C21.75 16.193 22.09 15.853 22.5 15.853C22.91 15.853 23.25 16.193 23.25 16.603V18.103C23.25 21.003 20.89 23.353 18 23.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.5 23.353H7C4.11 23.353 1.75 21.003 1.75 18.103V15.603C1.75 15.193 2.09 14.853 2.5 14.853C2.91 14.853 3.25 15.193 3.25 15.603V18.103C3.25 20.173 4.93 21.853 7 21.853H9.5C9.91 21.853 10.25 22.193 10.25 22.603C10.25 23.013 9.91 23.353 9.5 23.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.5 5.85303H7.5C6.36 5.85303 5.75 6.45303 5.75 7.60303V9.60303C5.75 10.753 6.36 11.353 7.5 11.353H9.5C10.64 11.353 11.25 10.753 11.25 9.60303V7.60303C11.25 6.45303 10.64 5.85303 9.5 5.85303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.5 5.85303H15.5C14.36 5.85303 13.75 6.45303 13.75 7.60303V9.60303C13.75 10.753 14.36 11.353 15.5 11.353H17.5C18.64 11.353 19.25 10.753 19.25 9.60303V7.60303C19.25 6.45303 18.64 5.85303 17.5 5.85303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.5 13.853H7.5C6.36 13.853 5.75 14.453 5.75 15.603V17.603C5.75 18.753 6.36 19.353 7.5 19.353H9.5C10.64 19.353 11.25 18.753 11.25 17.603V15.603C11.25 14.453 10.64 13.853 9.5 13.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.5 13.853H15.5C14.36 13.853 13.75 14.453 13.75 15.603V17.603C13.75 18.753 14.36 19.353 15.5 19.353H17.5C18.64 19.353 19.25 18.753 19.25 17.603V15.603C19.25 14.453 18.64 13.853 17.5 13.853Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBarcode);
export default __webpack_public_path__ + "static/media/scan-barcode.f115f2f2dd706a6f6ede68889176e972.svg";
export { ForwardRef as ReactComponent };